/* Brand CSS must load after Bootstrap, and before page CSS chunks */
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import "./components/shared/dashboardThemeUnify.css";
import "react-tooltip/dist/react-tooltip.css";

import Dashboard from "./components/Dashboard-content/Dashboard";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import FitnessManagerDashboard from "./components/FitnessManagerDashboard/FitnessManagerDashboard";
import SocialMediaDashboard from "./components/SocialMediaDashboard/SocialMediaDashboard";
import RoleAccessManager from "./components/Admin/RoleAccessManager";
import MenuPathGate from "./components/MenuPathGate";
import ViewClients from "./components/ViewClients/ViewClients";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,  
  Navigate,  
} from "react-router-dom"; 
import AddClients from "./components/AddClients/AddClients";
import ClientsReports from "./components/ClientsReports/ClientsReports";
import ViewTrainer from "./components/ViewStaffMember/ViewTrainer";
import AddStaffMembers from "./components/AddStaffMembers/AddStaffMembers";
import StaffAdjustments from "./components/StaffAdjustments/StaffAdjustments";
import AddSalaryComponent from "./components/AddSalaryComponent/AddSalaryComponent";
import ManageStaffSalary from "./components/ManageStaffSalary/ManageStaffSalary";
import ViewGymPackages from "./components/GymPackages/ViewGymPackages";
import DetailedPackages from "./components/Packages/DetailedPackages";
import DetailedSalesReport from "./components/SalesHistoryReports/DetailedSalesReport";
import ActiveClientsReport from "./components/Reports/ActiveClientsReport";
import AddTrainerPackages from "./components/AddTrainerPackages/AddTrainerPackages";
import PackageSell from "./components/SellPackage/PackageSell";
import ManageExpenses from "./components/AddExpence/ManageExpenses";
import ManageProducts from "./components/ManageProducts/ManageProducts";
import AddnewProduct from "./components/AddNewProducts/AddnewProduct";
import ReportsAll from "./components/ReportsAll/ReportsAll";
import SendSms from "./components/SendSms/SendSms";
import ClientAssesment from "./components/ClientAssesment/ClientAssesment";
import ClientHome from "./components/ClientHome/ClientHome";
import StaffHome from "./components/StaffHome/StaffHome";
import ManageBranches from "./components/ManageBranches/ManageBranches";
import ClientPurchases from "./components/ClientPurchases/ClientPurchases";
import StaffAttendance from "./components/StaffAttendance/StaffAttendance";
import ManageTowels from "./components/ManageTowels/ManageTowels";
import LockerBoard from "./components/Lockers/LockerBoard";
import InventoryModule from "./components/Inventory/InventoryModule";
import SalesHistoryreports from "./components/SalesHistoryReports/SalesHistoryreports";
import AddNewGroupSession from "./components/AddNewGroupSession/AddNewGroupSession";
import ViewCardsHistory from "./components/ViewCardsHsitory/ViewCardsHistory";
import AddGroupTime from "./components/AddGroupTime/AddGroupTime";
import AddNutritionPackage from "./components/AddNutritionPackage/AddNutritionPackage";
import SearchClient from "./components/SearchClient/SearchClient";
import Capture from "./components/CaptureImage/Capture";
import NewCard from "./components/NewCard/NewCard";
import StaffNewCard from "./components/NewCard/StaffNewCard";
import Login from "./components/Logindemo/Login";
import RoleHomeRedirect from "./components/RoleHomeRedirect";
import { getRoleHomePath, usesTrainerPortal } from "./utils/roleHome";
import {
  getCachedMenu,
  isCatalogPath,
  isMenuAccessPending,
  isStaffAssessmentPath,
  loadMenuAccess,
  pathAllowed,
  subscribeMenuCache,
} from "./utils/menuAccessCache";
import { legacyAllowsPath } from "./utils/legacyRouteAccess";
import VostroCard from "./components/VostroCard/VostroCard";
import { useContext, useEffect, useState } from "react";
import { NoteState } from "./context/notes/NoteState";
import UserServices from "./UserServices/UserServices";
import jwtDecode from "jwt-decode";
import UpdateBranches from "./components/ManageBranches/UpdateBranches";
import AddMembershipPackage from "./components/MembershipType/AddMembershipPackage";
import ViewClientAssesment from "./components/ClientAssesment/ViewClientAssesment";
import PostAssessment from "./components/ClientAssesment/PostAssessment";
import VisitorCard from "./components/NewCard/VisitorCard";
import CartForPayment from "./components/SellPackage/CartForPayment";
import RecievePayments from "./components/ClientPurchases/RecievePayments";
import ViewAllCards from "./components/ViewCardsHsitory/ViewAllCards";
import AccountDetails from "./components/ClientPurchases/AccountDetails";
import UpdateDates from "./components/ClientPurchases/UpdateDates";
import ClientAttendence from "./components/AttendanceReports/ClientAttendence";
// import SalesReport from "./components/SalesHistoryReports/SalesReport";
import Slip from "./components/Includes/Invoice/Slip";
import ResourceManager from "./components/ResourceManager/ResourceManager";
import UpdateResource from "./components/ResourceManager/UpdateResource";
import SessionAttendance from "./components/SessionAttendance/SessionAttendance";
import SingleClientAttendance from "./components/AttendanceReports/SingleClientAttendance";
import SingleStaffAttendance from "./components/StaffAttendance/SingleStaffAttendance";
import UpdateTrainerAttendance from "./components/SessionAttendance/UpdateTrainerAttendance";
import CardBack from "./components/VostroCard/CardBack";
import StaffCard from "./components/StaffCard/StaffCard";
import PrintVisitorCard from "./components/StaffCard/PrintVisitorCard";
import Renewal from "./components/Renewal/Renewal";
import NotFound from "./components/Includes/NotFound";
import FreezingManagement from "./components/FreezingFee/FreezingManagement";
import PublicFreezingRequest from "./components/FreezingFee/PublicFreezingRequest";
import ClientDashboard from "./components/ClientPortal/ClientDashboard";
import ClientChangePassword from "./components/ClientPortal/ClientChangePassword";
import ExcelImport from "./components/ExcelImport/ExcelImport";
import UserRole from "./components/UserRole/UserRole";
import UpdateRole from "./components/UserRole/UpdateRole";
import UnAuthorized from "./components/Includes/UnAuthorized";
import Discounts from "./components/Discounts/Discounts";
import GenralPackage from "./components/MembershipType/GenralPackage";
import AddCategories from "./components/Finance/AddCategories";
import AddSubCategories from "./components/Finance/AddSubCategories";
import Cafe from "./components/MembershipType/Cafe";
import OfficeCash from "./components/Finance/OfficeCash";
import LiabilitiesManagement from "./components/Finance/LiabilitiesManagement";
import Assets from "./components/Finance/Assets";
import UpdateAssets from "./components/Finance/UpdateAssets";
import FinanceDashboard from "./components/Finance/FinanceDashboard";
import FinanceV2Dashboard from "./components/FinanceV2/FinanceV2Dashboard";
import FinanceV2SetupWizard from "./components/FinanceV2/FinanceV2SetupWizard";
import FinanceV2Reports from "./components/FinanceV2/FinanceV2Reports";
import FinanceV2ChartOfAccounts from "./components/FinanceV2/FinanceV2ChartOfAccounts";
import FinanceV2Journals from "./components/FinanceV2/FinanceV2Journals";
import FinanceV2Transactions from "./components/FinanceV2/FinanceV2Transactions";
import FinanceV2GeneralLedger from "./components/FinanceV2/FinanceV2GeneralLedger";
import FinanceV2BankReconcile from "./components/FinanceV2/FinanceV2BankReconcile";
import FinanceV2Receivables from "./components/FinanceV2/FinanceV2Receivables";
import FinanceV2FiscalPeriods from "./components/FinanceV2/FinanceV2FiscalPeriods";
import FinanceV2ImportCenter from "./components/FinanceV2/FinanceV2ImportCenter";
import FinanceV2Guides from "./components/FinanceV2/FinanceV2Guides";
import FinanceV2Mappings from "./components/FinanceV2/FinanceV2Mappings";
import FinanceV2AuditLog from "./components/FinanceV2/FinanceV2AuditLog";
import HRDashboard from "./components/HR/HRDashboard";
import EmployeeDashboard from "./components/EmployeeDashboard/EmployeeDashboard";
import AnnouncementManager from "./components/Announcements/AnnouncementManager";
import SOPManager from "./components/SOPs/SOPManager";
import SOPViewer from "./components/SOPs/SOPViewer";
import DetailedHRReport from "./components/HR/DetailedHRReport";
import BalanceSheet from "./components/Finance/BalanceSheet";
import DailySales from "./components/Finance/DailySales";
import DailyReport from "./components/Finance/DailyReport";
import SocialLeads from "./components/SocialLeads/SocialLeads";
import DailyOfficeClosing from "./components/Finance/DailyOfficeClosing";
import CafeSalesExpenseReport from "./components/Finance/CafeSalesExpenseReport";
import TaxSettings from "./components/TaxSettings/TaxSettings";
import BankDetails from "./components/Finance/BankDetails";
import ViewExpenses from "./components/AddExpence/ViewExpenses";
import GetOfficeCash from "./components/Finance/GetOfficeCash";
import GetCashInHand from "./components/Finance/GetCashInHand";
import AddCharity from "./components/Finance/AddCharity";
import GetCharity from "./components/Finance/GetCharity";
import VostroExpense from "./components/Finance/VostroExpense";
import VostroExpenseReport from "./components/Finance/VostroExpenseReport";
import PaidExpenseReport from "./components/Finance/PaidExpenseReport";
import GetLiabilities from "./components/Finance/GetLiabilities";
import PayLiabilities from "./components/Finance/PayLiabilities";
import SalesReportNew from "./components/SalesHistoryReports/SalesReportNew";
import CafeDashboard from "./components/Cafe-dashboard/CafeDashboard";
import CafeOverviewDashboard from "./components/CafeOverview/CafeOverviewDashboard";
import AdminReminders from "./components/AdminReminders/AdminReminders";
import GymAssets from "./components/GymAssets/GymAssets";
import GymAssetForm from "./components/GymAssets/GymAssetForm";
import GymAssetDetail from "./components/GymAssets/GymAssetDetail";
import GymMaintenance from "./components/GymAssets/GymMaintenance";
import FacilityDashboard from "./components/GymAssets/FacilityDashboard";
import CafeCheckOut from "./components/Cafe-dashboard/CafeCheckOut";
import BankLedger from "./components/Finance/BankLedger";
import GetBankLedger from "./components/Finance/GetBankLedger";
import CafeCart from "./components/Cafe-dashboard/CafeCart";
import PayLoans from "./components/StaffLones/PayLoans";
import SalesReportBootcamp from "./components/SalesHistoryReports/SalesReportBootcamp";
import AddCafe from "./components/Cafe-dashboard/AddCafe";
import UpdateCafeProduct from "./components/Cafe-dashboard/UpdateCafeProduct";
import CafeSlip from "./components/Cafe-dashboard/CafeSlip";
import CafeSales from "./components/Cafe-dashboard/CafeSales";
import CFT from "./components/MembershipType/CFT";
import Sidebar from "./components/Includes/Sidebar/Sidebar";
import Navbar from "./components/Includes/Navbar/Navbar";
import PettyCash from "./components/Finance/PettyCash";
import GetPettyCash from "./components/Finance/GetPettyCash";
import KneeLedger from "./components/Finance/KneeLedger";
import FootfallReport from "./components/AttendanceReports/footfall/FootfallReport";
import BranchLedger from "./components/Finance/BranchLedger";
import GetBranchLedger from "./components/Finance/GetBranchLedger";
import KeeneLedger from "./components/Finance/KeeneLedger";
import Approvals from "./components/Approvals/Approvals";
import PersonalTrainer from "./components/Fitness/PersonalTrainer";
import SlotManage from "./components/Fitness/SlotManage";
import CafeCategory from "./components/Cafe-dashboard/CafeCategory";
import MassageChair from "./components/MassageChair/MassageChair";
import TransactionReportNew from "./components/SalesHistoryReports/TransactionReportNew";
import AssignTimeSlots from "./components/Fitness/AssignTimeSlots";
import CafeSalesReport from "./components/SalesHistoryReports/CafeSalesReport";
import DetailedCafeReport from "./components/SalesHistoryReports/DetailedCafeReport";
import ClientDetailsReport from "./components/Reports/ClientDetailsReport";
//adeeldev
import SalesExpenseDaily from "./components/SalesHistoryReports/SalesExpenseDaily";
import CashInHand from "./components/Finance/CashInHand"; 
// import CafeInvoice from "./components/Cafe-dashboard/CafeInvoice";
import CafeDeposit from "./components/MembershipType/CafeDeposit";
import DepositClientBalance from "./components/MembershipType/DepositClientBalance";
import Deposit from "./components/MembershipType/Deposit";
import DepositsHistory from "./components/MembershipType/DepositsHistory";
import CafeDepositCheckOut from "./components/MembershipType/CafeDepositCheckOut";
import ViewDepositBalance from "./components/MembershipType/ViewDepositBalance";
import AddPhysiotherapy from "./components/MembershipType/AddPhysiotherapy";
import CafeDepositSlip from "./components/Includes/Invoice/CafeDepositSlip";
import NewCafeReport from "./components/SalesHistoryReports/NewCafeReport";
import AddCafeCtegory from "./components/MembershipType/AddCafeCtegory";
import ManagmentIncoive from "./components/Cafe-dashboard/ManagmentIncoive";
import ManagementPendings from "./components/SalesHistoryReports/ManagementPendings";
import RecievePendings from "./components/SalesHistoryReports/RecievePendings";
import AddModule from "./components/Permissions/AddModule";
import LiabilitiesLedger from "./components/Finance/LiabilitiesLedger";
import AddLiabilitiesLedger from "./components/Finance/AddLiabilitiesLedger";
import AddMealPlan from "./components/Fitness/MealPlans/AddMealPlan";
import NutritionAssessments from "./components/Fitness/Assessment/NutritionAssessments";
import NutritionDashboard from "./components/Nutrition/NutritionDashboard";
import NutritionAppointments from "./components/Nutrition/NutritionAppointments";
import NutritionHealthCamps from "./components/Nutrition/NutritionHealthCamps";
import NutritionReferrals from "./components/Nutrition/NutritionReferrals";
import NutritionClientDetails from "./components/Nutrition/NutritionClientDetails";
import NutritionGallery from "./components/Nutrition/NutritionGallery";
import NutritionistAssessmentFormList, {
  NutritionistAssessmentFormPage,
} from "./components/Nutrition/NutritionistAssessmentForm";
import PhysioAppointments from "./components/Physio/PhysioAppointments";
import PhysioPrescriptions from "./components/Physio/PhysioPrescriptions";
import PhysioGX from "./components/Physio/PhysioGX";
import PhysioDailyReferrals from "./components/Physio/PhysioDailyReferrals";
import PhysioPatientDetails from "./components/Physio/PhysioPatientDetails";
import PhysioClientResponses from "./components/Physio/PhysioClientResponses";
import PhysioDashboard from "./components/Physio/PhysioDashboard";
import PhysioAssessments from "./components/Physio/PhysioAssessments";
import ViewNutritionAssessments from "./components/Fitness/Assessment/ViewNutritionAssessments";
import EditNutritionAssessments from "./components/Fitness/Assessment/EditNutritionAssessments";
import EditMealPlan from "./components/Fitness/MealPlans/EditMealPlan";
import ViewMealPlans from "./components/Fitness/MealPlans/ViewMealPlans";
import AddMealPlanBK from "./components/Fitness/MealPlans/AddMealPlanBK";
import ViewMealPlansDetail from "./components/Fitness/MealPlans/ViewMealPlansDetail";
import TrainerClient from "./components/TrainerClient/TrainerClient";
//adeel
import MISReport from "./components/MISReport/MISReport.jsx";
import ClientVerification from "./components/ClientVerification/ClientVerification";

//adeel

import TrainerDairy from "./components/Fitness/TrainerDairy";
import AssignSlotToClient from "./components/Fitness/AssignSlotToClient";
import ViewClientsPkgs from "./components/Fitness/ViewClientsPkgs";
import AssignTimeToClient from "./components/Fitness/AssignTimeToClient";
import ViewClientPreAssesmentList from "./components/ClientAssesment/ViewClientPreAssesmentList";
import ViewClientPostAssesmentList from "./components/ClientAssesment/ViewClientPostAssesmentList";
import NewPtBookings from "./components/Fitness/NewPtBookings";
import TrainerAppointments from "./components/Fitness/TrainerAppointments";
import AssignDaysToSlots from "./components/Fitness/AssignDaysToSlots";
import PTSessionAttendance from "./components/Fitness/PTSessionAttendance";
import PTReport from "./components/Fitness/PTReport";
import PTSessionAttendanceReport from "./components/Fitness/PTSessionAttendanceReport";
import AddPostAssmnt from "./components/ClientAssesment/AddPostAssmnt";
import AddPreAssmnt from "./components/ClientAssesment/AddPreAssmnt";
import ViewClientAssesmentInfo from "./components/ClientAssesment/ViewClientAssesmentInfo";
import ClientInduction from "./components/ClientAssesment/ClientInduction";
import ClientAssmentCompre from "./components/ClientAssesment/ClientAssmentCompre";
import FitnessTracker from "./components/Fitness/FitnessTracker";
import ManageExercises from "./components/Fitness/Exercises/ManageExercises";
import PlanListing from "./components/Fitness/FitnessPlans/PlanListing";
import DetailPlan from "./components/Fitness/FitnessPlans/DetailPlan";
import AddFitnessPlan from "./components/Fitness/FitnessPlans/AddFitnessPlan";
import UpdateFitnessPlan from "./components/Fitness/FitnessPlans/UpdateFitnessPlan";
import SwitchTimeForClient from "./components/Fitness/SwitchTimeForClient";
import NewAddFitnessPlan from "./components/Fitness/NewFitnessPlan/NewAddFitnessPlan";
import CreatePlan from "./components/Fitness/NewFitnessPlan/CreatePlan";
import AddGfxPackage from "./components/AddGfxPackage/AddGfxPackage";
import GxClasses from "./components/Fitness/GxClasses";
import GxClassesAttendence from "./components/Fitness/GxClassesAttendence";
import GxAttendenceReport from "./components/Fitness/GxAttendenceReport";
import GXAppointments from "./components/Fitness/GXAppointments";
import AddBefitAssessments from "./components/AddBefitAssessments/AddBefitAssessments";
import ViewClientsBefits from "./components/Fitness/ViewClientsBefits";
import AddGfxClasses from "./components/AddGfxClasses/AddGfxClasses";
import AddGfxTrainers from "./components/AddGfxTrainers/AddGfxTrainers";
import NewGXBookings from "./components/Fitness/NewGXBookings";
import AddClassesInGxSlots from "./components/AddClassesInGxSlots/AddClassesInGxSlots";
import NewBefitBookings from "./components/Fitness/NewBefitBookings";
import BefitAppointments from "./components/Fitness/BefitAppointments";
import BefitSessionAttendance from "./components/Fitness/BefitSessionAttendance";
import BefitSessionAttendanceReport from "./components/Fitness/BefitSessionAttendanceReport";
import UpdateBefitAttendance from "./components/Fitness/UpdateBefitAttendance";
import ViewClientsSPT from "./components/Fitness/ViewClientsSPT";
import SPTAppointments from "./components/Fitness/SPTAppointments";
import NewSPTBookings from "./components/Fitness/NewSPTBookings";
import SPTAttendence from "./components/Fitness/SPTAttendence";
import SPTAttendenceReport from "./components/Fitness/SPTAttendenceReport";
import StaffProfile from "./components/StaffHome/StaffProfile";
import Employeeattendance from "./components/StaffAttendance/Employeeattendance";
import NeewSPTBookings from "./components/Fitness/NeewSPTBookings";
import StaffDeutyHours from "./components/StaffAttendance/StaffDeutyHours";
import StaffPromotion from "./components/ManageStaffSalary/StaffPromotion";
import StaffSalary from "./components/ManageStaffSalary/StaffSalary";
import StaffCommision from "./components/StaffCommision/StaffCommision";
import LeaveQuota from "./components/ManageStaffSalary/LeaveQuota";
import LeaveApplication from "./components/StaffAttendance/LeaveApplication";
import SalarySlip from "./components/ManageStaffSalary/SalarySlip";
import LetterManagement from "./components/LettersManagement/LetterManagement";
import CertificateOfEmployment from "./components/LettersManagement/CertificateOfEmployement";
import AppointmentLetter from "./components/LettersManagement/AppointmentLetter";
import ConfirmationLetter from "./components/LettersManagement/ConformationLetter";
import WarningLetter from "./components/LettersManagement/WarningLetter";
import OfferLetter from "./components/LettersManagement/OfferLetter";
import BankAccountLetter from "./components/LettersManagement/BankAccountLetter";
import ExitInterviewForm from "./components/LettersManagement/ExitInterviewForm";
import EmployeClearanceForm from "./components/LettersManagement/EmployeClearanceForm";
// import InvoiceCafee from "./components/Cafe-dashboard/InvoiceCafee";

// ── Commission Portal ─────────────────────────────────────────────────────
import TrainerPortal from "./components/TrainerPortal/TrainerPortal";
import PtDashboard from "./components/PtDashboard/PtDashboard";
import TrainerSlots from "./components/TrainerSlots/TrainerSlots";
import GtDashboard from "./components/GtDashboard/GtDashboard";
import HRAttendancePortal from "./components/HRAttendancePortal/HRAttendancePortal";
/* Last CSS import — brand red/black must win over Bootstrap + page styles */
import "./brand-theme.css";

/** Roles allowed to create/edit SOPs — mirrors SopController::canManage(). */
const SOP_MANAGER_ROLES = ["1", "11", "12"];

/** Legacy role list OR dynamic menu grant for current path. */
function staffCanOpen(role, legacyRoles, pathname) {
  if (isStaffAssessmentPath(pathname)) return true;
  const path = String(pathname ?? "");
  if (path === "/mis-report" || path.startsWith("/mis-report/")) {
    return String(role ?? "") === "1";
  }
  const roleStr = String(role ?? "");
  const cached = getCachedMenu(roleStr);
  const allLinks = cached?.all_link_paths || [];
  const allowed = cached?.allowed_paths || [];
  const known = allLinks.length > 0 && isCatalogPath(allLinks, pathname);
  // The menu grant is still loading. Don't flash the 403 before it arrives.
  if (isMenuAccessPending(roleStr)) return true;
  // Role & Menu Access is the source of truth for items that exist in the menu.
  if (known) return pathAllowed(allowed, pathname);
  if ((legacyRoles || []).map(String).includes(roleStr)) return true;
  if (legacyAllowsPath(roleStr, pathname)) return true;
  return false;
}

function isClientToken(accessToken) {
  if (!accessToken) return false;
  try {
    const decoded = jwtDecode(accessToken);
    return decoded?.typ === "client" || decoded?.guard === "api_client";
  } catch {
    return false;
  }
}

function App() {
  const { state, dispatch: ctxDispatch } = useContext(NoteState);
  const { accessToken, role, accountType, designation_id } = state;
  const roleStr = String(role ?? "");
  const [menuEpoch, setMenuEpoch] = useState(0);
  const isClient =
    roleStr === "client" ||
    accountType === "client" ||
    isClientToken(accessToken);
  const locate = useLocation();
  const navigate = useNavigate();
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => subscribeMenuCache(() => setMenuEpoch((n) => n + 1)), []);

  useEffect(() => {
    if (!accessToken || isClient || !roleStr) return undefined;
    let cancelled = false;
    loadMenuAccess(
      roleStr,
      () => UserServices.getMyMenuAccess().then((res) => res?.data?.data),
      { refresh: true }
    ).catch(() => {
      if (!cancelled) setMenuEpoch((n) => n + 1);
    });
    return () => {
      cancelled = true;
    };
  }, [accessToken, isClient, roleStr]);

  useEffect(() => {
    // if (!branch_id) {
    //   ctxDispatch({
    //     type: "LOGOUT",
    //   });

    //   navigate("/");
    // } else
     if (accessToken) {
      var decoded = jwtDecode(accessToken);
      if (Math.floor(new Date().getTime() / 1000) > decoded.exp) {
        ctxDispatch({
          type: "LOGOUT",
        });

        navigate("/");
      } else if (isClient) {
        const clientAllowed = [
          "/client-dashboard",
          "/client-change-password",
        ];
        if (!clientAllowed.includes(locate.pathname)) {
          navigate(
            state.mustChangePassword
              ? "/client-change-password"
              : "/client-dashboard"
          );
        }
      } else if (locate.pathname === "/") {
        navigate(getRoleHomePath(roleStr, designation_id));
      } else if (
        !isClient &&
        roleStr &&
        locate.pathname !== "/unauthorized"
      ) {
        // Dynamic menu revoke: block known menu paths the role no longer has
        const cached = getCachedMenu(roleStr);
        const allLinks = cached?.all_link_paths || [];
        const allowed = cached?.allowed_paths || [];
        if (
          cached &&
          !isMenuAccessPending(roleStr) &&
          allLinks.length &&
          !isStaffAssessmentPath(locate.pathname) &&
          isCatalogPath(allLinks, locate.pathname) &&
          !pathAllowed(allowed, locate.pathname) &&
          !legacyAllowsPath(roleStr, locate.pathname)
        ) {
          navigate("/unauthorized", { replace: true });
        }
      }
    } else {
      if (
        locate.pathname !== "/client-verification" &&
        locate.pathname !== "/freezing-request"
      ) {
        navigate("/");
      }
    }
  }, [locate.pathname, accessToken, isClient, roleStr, designation_id, menuEpoch]);

  return (
    <>
      {locate.pathname !== "/" &&
      locate.pathname !== "/freezing-request" &&
      locate.pathname !== "/client-verification" &&
      locate.pathname !== "/client-dashboard" &&
      locate.pathname !== "/client-change-password" &&
      accessToken &&
      !isClient &&
      (role !== "7" || locate.pathname === "/employee-dashboard") ? (
        <>
          <Sidebar /> <Navbar />
        </>
      ) : null}
      <Routes>
        <Route exact path="/client-verification" element={<ClientVerification />} />
        <Route exact path="/freezing-request" element={<PublicFreezingRequest />} />
        <Route
          exact
          path="/client-dashboard"
          element={
            isClient ? (
              <ClientDashboard />
            ) : accessToken ? (
              <RoleHomeRedirect />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          exact
          path="/client-change-password"
          element={
            isClient ? (
              <ClientChangePassword />
            ) : accessToken ? (
              <RoleHomeRedirect />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route exact path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            isClient ? (
              <Navigate to="/client-dashboard" />
            ) : role === "1" ? (
              <Navigate to="/admin-dashboard" replace />
            ) : staffCanOpen(role, ["3", "4"], locate.pathname) ? (
              <Dashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/admin-dashboard"
          element={
            staffCanOpen(role, ["1"], locate.pathname) ? (
              <AdminDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/admin-reminders"
          element={
            staffCanOpen(role, ["1"], locate.pathname) ? (
              <AdminReminders />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/gym-assets"
          element={
            staffCanOpen(role, ["1", "3", "12"], locate.pathname) ? (
              <GymAssets />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/gym-assets/new"
          element={
            staffCanOpen(role, ["1", "3", "12"], locate.pathname) ? (
              <GymAssetForm />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/gym-assets/:id/edit"
          element={
            staffCanOpen(role, ["1", "3", "12"], locate.pathname) ? (
              <GymAssetForm />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/gym-assets/:id"
          element={
            staffCanOpen(role, ["1", "3", "12"], locate.pathname) ? (
              <GymAssetDetail />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/gym-maintenance"
          element={
            staffCanOpen(role, ["1", "3", "12"], locate.pathname) ? (
              <GymMaintenance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/facility-dashboard"
          element={
            staffCanOpen(role, ["1", "3", "12"], locate.pathname) ? (
              <FacilityDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-overview"
          element={
            staffCanOpen(role, ["1", "3"], locate.pathname) ? (
              <CafeOverviewDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/admin/role-access"
          element={
            <MenuPathGate legacyAllowed={["1"]}>
              <RoleAccessManager />
            </MenuPathGate>
          }
        />
        <Route
          path="/fitness-manager-dashboard"
          element={
            staffCanOpen(role, ["1", "3", "11"], locate.pathname) ? (
              <FitnessManagerDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/pt-dashboard"
          element={
            staffCanOpen(role, ["1", "3", "9", "11"], locate.pathname) ||
            usesTrainerPortal(role, designation_id) ? (
              <PtDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/trainer-slots"
          element={
            staffCanOpen(role, ["1", "3", "4", "9", "11"], locate.pathname) ? (
              <TrainerSlots />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/gt-dashboard"
          element={
            staffCanOpen(role, ["1", "3", "11", "17"], locate.pathname) ? (
              <GtDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/social-media-dashboard"
          element={
            staffCanOpen(role, ["1", "3", "16"], locate.pathname) ? (
              <SocialMediaDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/employee-dashboard"
          element={
            isClient ? (
              <Navigate
                to={
                  state.mustChangePassword
                    ? "/client-change-password"
                    : "/client-dashboard"
                }
              />
            ) : accessToken ? (
              <EmployeeDashboard />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/announcements"
          element={
            isClient ? (
              <Navigate to="/client-dashboard" />
            ) : (
              <MenuPathGate legacyAllowed={["1", "11", "12"]}>
                <AnnouncementManager />
              </MenuPathGate>
            )
          }
        />
        <Route
          path="/sops"
          element={
            SOP_MANAGER_ROLES.includes(String(role)) ? (
              <SOPManager />
            ) : ["9", "12"].includes(String(role)) || staffCanOpen(role, ["9", "12"], locate.pathname) ? (
              <SOPViewer />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-clients"
          element={
            staffCanOpen(role, ["3", "1", "4", "10", "11"], locate.pathname) ? (
              <ViewClients />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-clients"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddClients />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/clients-reports"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <ClientsReports />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
{/* //adeel */}
        <Route
          path="/mis-report"
          element={
            staffCanOpen(role, ["1"], locate.pathname) ? (
              <MenuPathGate legacyAllowed={["1"]}>
                <MISReport />
              </MenuPathGate>
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

{/* //adeel */}

        <Route
          path="/view-staff"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <ViewTrainer />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-staff"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <AddStaffMembers />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-staff-promotion"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <StaffPromotion />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/letter-managemnt"
          element={
            staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
              <LetterManagement />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/certificate-of-employment/:id"
          element={
            staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
              <CertificateOfEmployment />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
         <Route
          path="/appointment-letter/:id"
          element={
            staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
              <AppointmentLetter />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
        path="/confirmation-letter/:id"
        element={
          staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
            <ConfirmationLetter />
          ) : (
            <RoleHomeRedirect />
          )
        }
      />
       <Route
        path="/warning-letter/:id"
        element={
          staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
            <WarningLetter />
          ) : (
            <RoleHomeRedirect />
          )
        }
      />
       <Route
        path="/exit-interview-form/:id"
        element={
          staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
            <ExitInterviewForm />
          ) : (
            <RoleHomeRedirect />
          )
        }
      />
        <Route
        path="/employee-clearance-form/:id"
        element={
          staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
            <EmployeClearanceForm />
          ) : (
            <RoleHomeRedirect />
          )
        }
      />
        <Route
          path="/offer-letter/:id"
          element={
            staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
              <OfferLetter />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/account-opening-letter/:id"
          element={
            staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
              <BankAccountLetter />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/leave-quota"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <LeaveQuota />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/staff-fines"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <StaffAdjustments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/staff-advances"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <StaffAdjustments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/salary-components"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <AddSalaryComponent />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/staff-salary"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <StaffSalary />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/staff-commission"
          element={
            staffCanOpen(role, ["3", "1", "4", "12", "11"], locate.pathname) ? (
              <StaffCommision />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        {/* ── Commission Portal: Trainer ─────────────────────────────── */}
        <Route
          path="/session-tracker"
          element={
            staffCanOpen(role, ["1", "3", "9", "11"], locate.pathname) ||
            usesTrainerPortal(role, designation_id) ? (
              <TrainerPortal />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        {/* ── Commission Portal: HR ──────────────────────────────────── */}
        <Route
          path="/hr-session-portal"
          element={
            staffCanOpen(role, ["1", "3", "11", "12", "9"], locate.pathname) ? (
              <HRAttendancePortal />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/staff-attendance"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <StaffAttendance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/staff-duty-hours"
          element={
            staffCanOpen(role, ["3", "1", "4", "12", "11"], locate.pathname) ? (
              <StaffDeutyHours />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/leave-application"
          element={
            staffCanOpen(role, ["3", "1", "4", "9", "11", "12"], locate.pathname) ? (
              <LeaveApplication />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/employee-attendance"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <Employeeattendance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route exact path="/get_pending/:id" element={<RecievePayments />} />
        <Route
          path="/gym-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <ViewGymPackages />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/detailed-packages"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <DetailedPackages />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/detailed-sales-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <DetailedSalesReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/active-clients-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <ActiveClientsReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/client-details-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <ClientDetailsReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/trainer-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddTrainerPackages />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-freezing"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <FreezingManagement />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/freezing-management"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <FreezingManagement />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/package-sell/:id"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <PackageSell />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/package-sell/:id/:type"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <PackageSell />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/sell-package/:id/:type"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <PackageSell />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/deposit/:id/:type"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <Deposit />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/check_out/:id"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <CartForPayment />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/check_out/:id/:type"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <CartForPayment />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-deposit"
          element={
            staffCanOpen(role, ["1", "3", "4", "7"], locate.pathname) ? (
              <CafeDeposit />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/deposit-client-balance"
          element={
            staffCanOpen(role, ["1", "3", "4", "7"], locate.pathname) ? (
              <DepositClientBalance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/clients-available-balance"
          element={
            staffCanOpen(role, ["1", "3", "4", "7"], locate.pathname) ? (
              <ViewDepositBalance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/deposit-history"
          element={
            staffCanOpen(role, ["1", "3", "4", "7"], locate.pathname) ? (
              <DepositsHistory />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe_check_out/:id/:type"
          element={
            staffCanOpen(role, ["1", "3", "4", "7"], locate.pathname) ? (
              <CafeDepositCheckOut />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/deposit_invoice/:type/:id"
          element={
            staffCanOpen(role, ["1", "3", "4", "7"], locate.pathname) ? (
              <CafeDepositSlip />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-expenses"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <ManageExpenses />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-expenses"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <ViewExpenses />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/vostro-expense"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <VostroExpense />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/vostro-expense-report"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <VostroExpenseReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/paid-expense-report"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <PaidExpenseReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route exact path="/manage-products" element={<ManageProducts />} />
        <Route exact path="/add-new-product" element={<AddnewProduct />} />
        <Route exact path="/report" element={<ReportsAll />} />
        <Route exact path="/send-sms" element={<SendSms />} />
        <Route exact path="/preAssessment/:id" element={<ClientAssesment />} />
        <Route
          exact
          path="/preAssessment"
          element={<ViewClientPreAssesmentList />}
        />
        <Route
          exact
          path="/client-induction/:id"
          element={<ClientAssmentCompre />}
        />
        <Route
          exact
          path="/client-assessment/:id"
          element={<ClientInduction />}
        />
        <Route
          exact
          path="/viewAssessment/:id"
          element={<ViewClientAssesment />}
        />
        <Route
          exact
          path="/viewAssessmentInfo/:id"
          element={<ViewClientAssesmentInfo />}
        />
        <Route
          exact
          path="/postAssessment"
          element={<ViewClientPostAssesmentList />}
        />
        {/*//? ..... */}
        <Route exact path="/add-pre-assessment" element={<AddPreAssmnt />} />
        <Route exact path="/add-post-assessment" element={<AddPostAssmnt />} />
        {/*//? ..... */}
        <Route exact path="/postAssessment/:id" element={<PostAssessment />} />
        <Route exact path="/client-home/:id" element={<ClientHome />} />
        <Route
          exact
          path="/client-purchases/:id"
          element={<ClientPurchases />}
        />
        <Route
          exact
          path="/account-details/:id"
          element={
            String(role) === "17" ? <RoleHomeRedirect /> : <AccountDetails />
          }
        />
        <Route
          path="/invoice/:type/:id"
          element={
            staffCanOpen(role, ["3", "1", "4", "9", "10"], locate.pathname) ? (
              <Slip />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-invoice/:type/:id"
          element={
            staffCanOpen(role, ["3", "1", "7", "4"], locate.pathname) ? (
              <CafeSlip />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-slip/:type/:id"
          element={
            staffCanOpen(role, ["3", "1", "7", "4"], locate.pathname) ? (
              <ManagmentIncoive />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route exact path="/update-dates/:id" element={<UpdateDates />} />
        {/* <Route exact path="/staff-profile/:id" element={<StaffHome />} /> */}
        <Route exact path="/staff-profile/:id" element={<StaffProfile />} />
        <Route exact path="/manage-branches" element={<ManageBranches />} />
        <Route exact path="/client-purchases" element={<ClientPurchases />} />
        <Route
          path="/manage-towels"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <ManageTowels />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/locker-management"
          element={
            staffCanOpen(role, ["1"], locate.pathname) ? (
              <LockerBoard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/inventory"
          element={
            staffCanOpen(role, ["1", "3", "7"], locate.pathname) ? (
              <InventoryModule />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/inventory/*"
          element={
            staffCanOpen(role, ["1", "3", "7"], locate.pathname) ? (
              <InventoryModule />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route exact path="/manage-sales" element={<Renewal />} />
        <Route
          path="/sales-by-services"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <SalesHistoryreports />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-sales"
          element={
            staffCanOpen(role, ["3", "1", "7", "4"], locate.pathname) ? (
              <CafeSales />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/sales-by-bootcamp"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <SalesReportBootcamp />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-sales-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5", "7"], locate.pathname) ? (
              <CafeSalesReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/detailed-cafe-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5", "7"], locate.pathname) ? (
              <DetailedCafeReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/sales-expense-daily"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <SalesExpenseDaily />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        <Route
          path="/cash-in-hand"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <CashInHand />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        <Route
          path="/new-cafe-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <NewCafeReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/management-pendings"
          element={
            staffCanOpen(role, ["3", "1", "4", "5", "7"], locate.pathname) ? (
              <ManagementPendings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/receive-pendings"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <RecievePendings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/sales-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <SalesReportNew />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/transactions-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <TransactionReportNew />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        {/* <Route
          exact
          path="/transactions-report"
          element={<TransactionReport />}
        /> */}
        <Route
          path="/attendance-report"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <ClientAttendence />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-bootcamp-calsses"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddNewGroupSession />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/assign-cards"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <ViewCardsHistory />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-group"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddGroupTime />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-nutrition-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddNutritionPackage />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-gx-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddGfxPackage />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/search-client"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <SearchClient />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route exact path="/webcam" element={<Capture />} />
        <Route
          path="/new-card/:id/:type"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <NewCard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-cards"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <ViewAllCards />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/assign_staff_card/:id/:type"
          element={<StaffNewCard />}
        />
        <Route exact path="/visitor-card/:id/:type" element={<VisitorCard />} />
        <Route
          path="/membership-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddMembershipPackage />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/physiotherapy-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddPhysiotherapy />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/massagechair"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <MassageChair />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cft-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <CFT />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route exact path="/staff-loans" element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <StaffAdjustments />
            ) : (
              <RoleHomeRedirect />
            )
          } />
        <Route exact path="/update-branches/:id" element={<UpdateBranches />} />
        <Route exact path="/resource-manager" element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <ResourceManager />
            ) : (
              <RoleHomeRedirect />
            )
          }/>
        <Route exact path="/update-resource/:id" element={<UpdateResource />} />
        <Route exact path="/pt-attendance" element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <SessionAttendance />
            ) : (
              <RoleHomeRedirect />
            )
          } />
        <Route
          exact
          path="/client-attendance/:id"
          element={<SingleClientAttendance />}
        />
        <Route
          exact
          path="/footfall-report"
          element={
            staffCanOpen(role, ["3", "4"], locate.pathname) ? (
              <FootfallReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route path="/footfall-gender" element={<Navigate to="/footfall-report" replace />} />
        <Route path="/footfall-branch" element={<Navigate to="/footfall-report" replace />} />
        <Route path="/footfall-peak" element={<Navigate to="/footfall-report" replace />} />
        <Route path="/footfall-reports" element={<Navigate to="/footfall-report" replace />} />
        <Route
          exact
          path="/staff-attendance-report/:id"
          element={<SingleStaffAttendance />}
        />
        <Route
          exact
          path="/update-pt-attendance/:id"
          element={<UpdateTrainerAttendance />}
        />
        <Route exact path="/print-client-card/:id" element={<VostroCard />} />
        <Route exact path="/print-staff-card/:id" element={<StaffCard />} />
        <Route exact path="/salary-slip/:id" element={<SalarySlip />} />
        <Route exact path="/update-role/:id" element={<UpdateRole />} />
        <Route exact path="/card-back" element={<CardBack />} />
        <Route
          exact
          path="/print-visitor-card"
          element={<PrintVisitorCard />}
        />
        <Route exact path="/excel-import" element={<ExcelImport />} />
        <Route exact path="/user-roles" element={<UserRole />} />
        <Route exact path="/manage-discounts" element={<Discounts />} />
        <Route exact path="*" element={<NotFound />} />
        <Route exact path="/unauthorized" element={<UnAuthorized />} />
        <Route
          path="/genral-package"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <GenralPackage />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/manage-categories"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <AddCategories />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/sub-categories"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <AddSubCategories />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/balance-sheet"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <BalanceSheet />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-dashboard"
          element={
            staffCanOpen(role, ["3", "1", "7", "4"], locate.pathname) ? (
              <CafeDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-category"
          element={
            staffCanOpen(role, ["3", "1", "7", "4"], locate.pathname) ? (
              <CafeCategory />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-cart"
          element={
            staffCanOpen(role, ["3", "1", "7", "4"], locate.pathname) ? (
              <CafeCart />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe_checkout"
          element={
            staffCanOpen(role, ["3", "1", "7", "4"], locate.pathname) ? (
              <CafeCheckOut />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-cafe-category"
          element={
            staffCanOpen(role, ["3", "1", "7"], locate.pathname) ? (
              <AddCafeCtegory />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route exact path="/cafe" element={<Cafe />} />
        <Route
          path="/add-cafe-product"
          element={
            staffCanOpen(role, ["3", "1", "7"], locate.pathname) ? (
              <AddCafe />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/update-cafe-product/:id"
          element={
            staffCanOpen(role, ["3", "1", "7"], locate.pathname) ? (
              <UpdateCafeProduct />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-office-cash"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <OfficeCash />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-cash-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <GetOfficeCash />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        <Route
          path="/view-cash-in-hand"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <GetCashInHand />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        <Route
          path="/add-charity"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <AddCharity />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-charity"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <GetCharity />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        <Route
          path="/add-keene"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <KeeneLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/keene-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <KneeLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/branch-cash-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <GetBranchLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-bank-cash"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <BankLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-petty-cash"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <PettyCash />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-branch-cash"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <BranchLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/petty-cash-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <GetPettyCash />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/bank-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <GetBankLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/liabilities-management"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <LiabilitiesManagement />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-liabilities"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <GetLiabilities />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/liabilities-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <LiabilitiesLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-liabilities-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <AddLiabilitiesLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/pay-liabilities/:id"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <PayLiabilities />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/pay-loan/:id"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <PayLoans />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/manage-assets"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <Assets />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/update-assets/:id"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <UpdateAssets />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-dashboard"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/setup"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2SetupWizard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/dashboard"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2Dashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/import"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2ImportCenter />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/guides"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2Guides />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/mappings"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2Mappings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/reports"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2Reports />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/chart-of-accounts"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2ChartOfAccounts />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/journals"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2Journals />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/transactions"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2Transactions />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/general-ledger"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2GeneralLedger />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/bank-reconcile"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2BankReconcile />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/receivables"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2Receivables />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/fiscal-periods"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2FiscalPeriods />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/finance-v2/audit-log"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <FinanceV2AuditLog />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/hr-dashboard"
          element={
            staffCanOpen(role, ["3", "1", "4", "12"], locate.pathname) ? (
              <HRDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/detailed-hr-report"
          element={
            staffCanOpen(role, ["3", "1", "12"], locate.pathname) ? (
              <DetailedHRReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/daily-report"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <DailyReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/social-leads"
          element={
            staffCanOpen(role, ["16", "1", "3"], locate.pathname) ? (
              <SocialLeads />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/social-leads-sales"
          element={
            staffCanOpen(role, ["4", "1", "3"], locate.pathname) ? (
              <SocialLeads salesMode />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/daily-sales-counter"
          element={
            staffCanOpen(role, ["3", "1", "5", "4"], locate.pathname) ? (
              <DailySales />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/cafe-sales-expense-report"
          element={
            staffCanOpen(role, ["3", "1", "4", "5"], locate.pathname) ? (
              <CafeSalesExpenseReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/daily-office-closing"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <DailyOfficeClosing />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/settings"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <TaxSettings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/bank-details"
          element={
            staffCanOpen(role, ["3", "1", "5"], locate.pathname) ? (
              <BankDetails />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/approval"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <Approvals />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        {/* <Route
          path="/fitness-plan"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <FitnessPlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        /> */}
        <Route
          path="/time-slot"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <SlotManage />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/assign-time-slot"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <AssignTimeSlots />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-module"
          element={
            staffCanOpen(role, ["3", "1", "4"], locate.pathname) ? (
              <AddModule />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/personal-trainer"
          element={
            staffCanOpen(role, ["3", "1", "4", "9", "11"], locate.pathname) ? (
              <PersonalTrainer />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/pt-sales-report"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <PTReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/trainer-diary"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <TrainerDairy />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/assign-slot/:trainer_id/:time_id/:assigned_id"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <AssignSlotToClient />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/session-attendance"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <PTSessionAttendance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/session-attendance-report"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <PTSessionAttendanceReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/update-session-attendance/:id"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <UpdateTrainerAttendance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-meal-plan"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <AddMealPlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-meal-plan-old"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <AddMealPlanBK />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-meal-plan"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <ViewMealPlans />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/detail-meal-plan/:id"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <ViewMealPlansDetail />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/edit-meal-plan/:id"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <EditMealPlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/nutrition-assessments"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <NutritionAssessments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/view-nutrition-assessments"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <ViewNutritionAssessments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/edit-nutrition-assessments/:id"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <EditNutritionAssessments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        {/* Nutrition Module Routes */}
        <Route
          exact
          path="/nutrition/dashboard"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutrition/appointments"
          element={
            staffCanOpen(role, ["10", "3", "1", "11", "4"], locate.pathname) ? (
              <NutritionAppointments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutrition/diet-plans"
          element={<Navigate to="/view-meal-plan" replace />}
        />
        <Route
          exact
          path="/nutrition/health-camps"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionHealthCamps />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutrition/referrals"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionReferrals />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutrition/gallery"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionGallery />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutrition/clients-details"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionClientDetails />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutritionist-assessment-form"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionistAssessmentFormList />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutritionist-assessment-form/new"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionistAssessmentFormPage />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/nutritionist-assessment-form/:id"
          element={
            staffCanOpen(role, ["10", "3", "1", "11"], locate.pathname) ? (
              <NutritionistAssessmentFormPage />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        {/* End Nutrition Module Routes */}
        {/* Physio Module Routes */}
        <Route
          exact
          path="/physio/dashboard"
          element={
            staffCanOpen(role, ["15", "3", "1"], locate.pathname) ? (
              <PhysioDashboard />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/physio/assessments"
          element={
            staffCanOpen(role, ["15", "3", "1"], locate.pathname) ? (
              <PhysioAssessments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/physio/appointments"
          element={
            staffCanOpen(role, ["15", "3", "1", "4"], locate.pathname) ? (
              <PhysioAppointments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/physio/prescriptions"
          element={
            staffCanOpen(role, ["15", "3", "1"], locate.pathname) ? (
              <PhysioPrescriptions />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/physio/gx"
          element={
            staffCanOpen(role, ["15", "3", "1"], locate.pathname) ? (
              <PhysioGX />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/physio/daily-referrals"
          element={
            staffCanOpen(role, ["15", "3", "1"], locate.pathname) ? (
              <PhysioDailyReferrals />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/physio/patient-details"
          element={
            staffCanOpen(role, ["15", "3", "1"], locate.pathname) ? (
              <PhysioPatientDetails />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/physio/client-responses"
          element={
            staffCanOpen(role, ["15", "3", "1"], locate.pathname) ? (
              <PhysioClientResponses />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        {/* End Physio Module Routes */}
        <Route
          exact
          path="/trainer-client/:id"
          element={
            staffCanOpen(role, ["3", "1", "4", "9", "11"], locate.pathname) ? (
              <TrainerClient />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/new-pt-packages"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <ViewClientsPkgs />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/assign-time/:client_id/:trainer_id"
          element={
            staffCanOpen(role, ["3", "1", "11", "9"], locate.pathname) ? (
              <AssignTimeToClient />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/switch-time"
          element={
            staffCanOpen(role, ["3", "1", "11", "9"], locate.pathname) ? (
              <SwitchTimeForClient />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/new-pt-bookings"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <NewPtBookings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/assign-days/:id/:tim_id/:start/:type"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <AssignDaysToSlots />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/trainer-appointments"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <TrainerAppointments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/fitness-tracker"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <FitnessTracker />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/manage-exercises"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <ManageExercises />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/fitness-plan"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <PlanListing />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/fitness-plan-detail/:id"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <DetailPlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-fitness-plan"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <CreatePlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-fitness-plan/:plan_id"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <NewAddFitnessPlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-fitness-plan-old"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <AddFitnessPlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/update-fitness-plan/:id"
          element={
            staffCanOpen(role, ["3", "1", "9", "11"], locate.pathname) ? (
              <UpdateFitnessPlan />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/gx-classes"
          element={
            staffCanOpen(role, ["3", "1", "11", "10"], locate.pathname) ? (
              <GxClasses />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/gx-classes-attendance"
          element={
            staffCanOpen(role, ["3", "1", "11", "10"], locate.pathname) ? (
              <GxClassesAttendence />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/gx-attendance-report"
          element={
            staffCanOpen(role, ["3", "1", "11", "10"], locate.pathname) ? (
              <GxAttendenceReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-gx-slots"
          element={
            staffCanOpen(role, ["3", "1", "4", "11", "10"], locate.pathname) ? (
              <AddGfxClasses />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          path="/add-gx-classes"
          element={
            staffCanOpen(role, ["3", "1", "4", "10", "11"], locate.pathname) ? (
              <AddClassesInGxSlots />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/gx-appointments"
          element={
            staffCanOpen(role, ["3", "1", "10", "11"], locate.pathname) ? (
              <GXAppointments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/gx-trainers"
          element={
            staffCanOpen(role, ["3", "1", "11", "10"], locate.pathname) ? (
              <AddGfxTrainers />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/befit-assessments/:id/:client_id"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <AddBefitAssessments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/befit-list"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <ViewClientsBefits />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        <Route
          exact
          path="/new-befit-bookings"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <NewBefitBookings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/befit-appointments"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <BefitAppointments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/befit-attendance"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <BefitSessionAttendance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/update-befit-attendance/:id"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <UpdateBefitAttendance />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/befit-attendance-report"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <BefitSessionAttendanceReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/new-gx-bookings"
          element={
            staffCanOpen(role, ["3", "1", "11", "10"], locate.pathname) ? (
              <NewGXBookings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        <Route
          exact
          path="/spt-list"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <ViewClientsSPT />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />

        {/* <Route
          exact
          path="/new-spt-bookings"
          element={
            staffCanOpen(role, ["3", "1", "11", "9"], locate.pathname) ? (
              <NewSPTBookings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        /> */}
        <Route
          exact
          path="/new-spt-bookings"
          element={
            staffCanOpen(role, ["3", "1", "11", "9"], locate.pathname) ? (
              <NeewSPTBookings />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/spt-appointments"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <SPTAppointments />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/spt-attendance"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <SPTAttendence />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
        <Route
          exact
          path="/spt-attendance-report"
          element={
            staffCanOpen(role, ["3", "1", "11"], locate.pathname) ? (
              <SPTAttendenceReport />
            ) : (
              <RoleHomeRedirect />
            )
          }
        />
      </Routes>
    </>
  );
}

export default App;
